export const SPLIT_CATEGORIES = [
  { key: 'csd', label: 'CSD' },
  { key: 'rnd', label: 'R&D' },
  { key: 'ops_admin', label: 'Ops' },
] as const;

export const INTEGRATION_PROVIDERS = ['clickup', 'google', 'granola'] as const;
